"use client";

import { motion } from "motion/react";
import Marquee from "react-fast-marquee";
import Image from "next/image";
import { urlFor } from "@/sanity/lib/image";
import { SanityPartner } from "@/sanity/lib/types";

const variant = {
  hidden: { opacity: 0 },
  visible: (index: number) => ({
    opacity: 1,
    transition: { delay: index * 0.05, duration: 2 },
  }),
};

interface LogoMarqueeProps {
  partners: SanityPartner[];
}

export default function LogoMarquee({ partners }: LogoMarqueeProps) {
  return (
    <section className="relative h-12 shrink-0 py-3 my-2 lg:my-4 md:h-18 md:py-5">
      <Marquee
        className="flex h-full"
        autoFill
        gradient={false}
        speed={50}
        delay={3}
      >
        {partners.map((partner, index) => (
          <motion.div
            key={partner._id}
            className="mx-6 flex h-6 items-center justify-center md:h-8"
            variants={variant}
            initial="hidden"
            animate="visible"
            transition={{ ease: [0, 1, 0.5, 1] }}
            custom={index}
          >
            <Image
              src={urlFor(partner.logo).width(120).height(60).url()}
              alt={partner.logo.alt || partner.name}
              width={120}
              height={60}
              className="h-full w-auto"
              loading="lazy"
            />
          </motion.div>
        ))}
      </Marquee>
    </section>
  );
}
